import service from '@/utils/server';

const modName = '/dataMsg/clockInData/';

//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

//导出excel
export const exportData = data => {
  let config = {
    timeout: 500000,
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/dataManagement/clockInData/api/index.js